import React from 'react';
import styles from './Breadcrumb.module.scss';
import { Layout } from '../Layout/Layout';

interface BreadcrumbProps {
  step: number;
  firstCollectionHandle?: string | null;
  secondCollectionHandle?: string | null;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ step }) => {
  const renderSteps = () => {
    const steps = step <= 3 ? [1, 2, 3] : [1, 2, 3, 4, 5, 6];

    return (
      <Layout>
        <div className={step <= 3 ? styles.breadcrumbLayout : styles.after}>
          <div className={styles.flex}>
            {steps.map((num) => (
              <span
                key={num}
                className={`${num === step ? styles.active : ''} ${num < step ? styles.completed : ''}`}
              >
                STEP{num}
              </span>
            ))}
          </div>
        </div>
      </Layout>
    );
  };

  return (
    <div className={styles.breadcrumb}>
      <div className={styles.bird}>
        <div className={styles.birdImage}></div>
        <div className={styles.steps}>
          {renderSteps()}
        </div>
      </div>
    </div>
  );
};